import WizardCard from './WizardCard.jsx';
import TitusPrincipleCard from './TitusPrincipleCard.jsx';
import { friendlyToday } from '../../lib/dates.js';

export default function StepGreeting({ onNext }) {
  return (
    <WizardCard
      step={1}
      title="Good morning, Jacob"
      subtitle={friendlyToday()}
      onNext={onNext}
      nextLabel="Begin"
      hideBack
    >
      <TitusPrincipleCard variant="embed" />
    </WizardCard>
  );
}
